import { createStore, compose, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import * as Sentry from '@sentry/react';
import { isSentryEnabled } from '../sentry';
import { appReducer } from './app';
import { quoteReducer } from './quote';

const composeEnhancers = (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({}))
  || compose;

const enhancers = [applyMiddleware(thunk)];
if (isSentryEnabled) {
  enhancers.push(Sentry.createReduxEnhancer());
}

const store = createStore(
  combineReducers({
    quote: quoteReducer,
    config: appReducer,
  }),
  {},
  composeEnhancers(...enhancers),
);

export default store;
